import { Box, Button, Card, Stack, styled, Typography } from '@mui/material';

export const TradeScoreCardContainer = styled(Box)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // height: isMobile ? 'auto' : theme.typography.pxToRem(270),
    paddingBottom: isMobile ? 0 : theme.spacing(1.125),
  }),
);

export const StyledCard = styled(Card)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    width: isMobile
      ? theme.typography.pxToRem(314)
      : theme.typography.pxToRem(407),
    maxWidth: isMobile
      ? theme.typography.pxToRem(314)
      : theme.typography.pxToRem(407),
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: theme.palette.info.main,
    borderRadius: theme.spacing(isMobile ? 10 : 6),
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
    padding: theme.spacing(6),
    marginBottom: isMobile ? 0 : '-9px',
    position: 'relative',
    overflow: 'hidden',
  }),
);

export const CloseButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.typography.pxToRem(26),
  right: theme.typography.pxToRem(24),
  zIndex: 1,
}));

export const InfoStack = styled(Stack)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    width: isMobile ? '100%' : theme.typography.pxToRem(359),
    justifyContent: 'space-between',
    height: isMobile
      ? theme.typography.pxToRem(316)
      : theme.typography.pxToRem(182),
    paddingTop: isMobile ? theme.spacing(3) : 0,
  }),
);

export const ContentStack = styled(Stack)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    width: isMobile ? '100%' : theme.typography.pxToRem(359),
  }),
);

export const ScoreMetricsStack = styled(Stack)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    width: '100%',
    gap: isMobile ? theme.spacing(4) : theme.spacing(2),
  }),
);

export const MetricsContainer = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.text.fifth,
  borderRadius: theme.spacing(5),
  overflow: 'hidden',
}));

export const MetricBox = styled(Box)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    backgroundColor: theme.palette.background.contrast,
    borderRight: '0.867px solid',
    borderColor: theme.palette.text.fifth,
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    width: theme.typography.pxToRem(87),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: isMobile
      ? theme.typography.pxToRem(58)
      : theme.typography.pxToRem(70),
    '&:last-child': {
      borderRight: 'none',
    },
  }),
);

export const MetricBoxMiddle = styled(Box)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    backgroundColor: theme.palette.background.contrast,
    borderRight: '0.867px solid',
    borderColor: theme.palette.text.fifth,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: isMobile
      ? theme.typography.pxToRem(58)
      : theme.typography.pxToRem(70),
  }),
);

export const MetricLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(12),
  lineHeight: 1.4,
  letterSpacing: '0.06px',
  color: theme.palette.text.primary,
}));

export const MetricValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1.4,
  letterSpacing: '0.03px',
  color: theme.palette.text.primary,
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: 1.5,
  letterSpacing: '0.07px',
  color: theme.palette.text.primary,
  padding: 0,
  margin: 0,
}));

export const DescriptionList = styled('ul')<{ isMobile?: boolean }>(
  ({ theme }) => ({
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.4,
    letterSpacing: '0.06px',
    color: theme.palette.text.secondary,
    padding: 0,
    margin: 0,
    marginTop: '0px !important',
    width: '100%',
    listStyle: 'disc',
    '& li': {
      marginBottom: 0,
      marginLeft: theme.typography.pxToRem(18),
      paddingLeft: 0,
      display: 'list-item',
    },
    '& li:last-child': {
      marginBottom: 0,
    },
  }),
);

export const DescriptionListItem = styled('li')(({ theme }) => ({
  padding: 0,
  marginBottom: 0,
  display: 'list-item',
  fontSize: theme.typography.pxToRem(12),
  lineHeight: 1.4,
  letterSpacing: '0.06px',
  color: theme.palette.text.secondary,
}));

export const DescriptionText = styled(Typography)<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => ({
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.4,
    letterSpacing: '0.06px',
    color: theme.palette.text.primary,
    textAlign: isMobile ? 'center' : 'left',
    width: isMobile ? '100%' : theme.typography.pxToRem(345),
    '& strong': {
      fontWeight: 500,
    },
  }),
);

export const ToggleButton = styled(Button)<{ isMobile?: boolean }>(
  ({ theme }) => ({
    height: theme.typography.pxToRem(36),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    borderRadius: theme.spacing(7.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    textTransform: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
);

export const ButtonText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(16),
  lineHeight: 1.5,
  letterSpacing: '0.08px',
  color: theme.palette.background.paper,
  textAlign: 'left',
}));

export const InfoTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(12),
  lineHeight: 1.4,
  letterSpacing: '0.06px',
  color: theme.palette.text.primary,
}));

export const InfoDescription = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(12),
  lineHeight: 1.4,
  letterSpacing: '0.06px',
  color: theme.palette.text.primary,
}));

export const ScoreIndicatorWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: theme.typography.pxToRem(102),
  height: theme.typography.pxToRem(102),
  flexShrink: 0,
}));

export const ScoreTextStack = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  paddingBottom: theme.spacing(2),
}));

export const ScoreNumber = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  letterSpacing: '0.03px',
  color: theme.palette.text.primary,
}));

export const ScoreLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(16),
  lineHeight: 1.5,
  letterSpacing: '0.08px',
  color: theme.palette.text.primary,
}));

export const SpeechBubblePointer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: theme.typography.pxToRem(17),
  height: theme.typography.pxToRem(17),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const SpeechBubblePointerInner = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(12),
  height: theme.typography.pxToRem(12),
  backgroundColor: theme.palette.background.paper,
  borderLeft: '1px solid',
  borderBottom: '1px solid',
  borderColor: theme.palette.info.main,
  borderRadius: theme.spacing(0.5),
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  borderBottomRightRadius: 0,
  transform: 'rotate(-45deg)',
}));
